export default "__VITE_ASSET__BquVvnrc__"